import { render } from "./CardBox2.vue?vue&type=template&id=04028ccf&scoped=true"
import script from "./CardBox2.vue?vue&type=script&lang=js"
export * from "./CardBox2.vue?vue&type=script&lang=js"

import "./CardBox2.vue?vue&type=style&index=0&id=04028ccf&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04028ccf"]])

export default __exports__